export const fileTypesEnum = {
    image: "img",
  };
  